/* unplugin-vue-components disabled */import { render } from "./rankOfficial.vue?vue&type=template&id=03c11d2e&scoped=true&ts=true"
import script from "./rankOfficial.vue?vue&type=script&lang=ts"
export * from "./rankOfficial.vue?vue&type=script&lang=ts"

import "./rankOfficial.vue?vue&type=style&index=0&id=03c11d2e&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c11d2e"],['__file',"src/views/rankList/cpns/rankOfficial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03c11d2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03c11d2e', __exports__)) {
    console.log('reload')
    api.reload('03c11d2e', __exports__)
  }
  
  module.hot.accept("./rankOfficial.vue?vue&type=template&id=03c11d2e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('03c11d2e', render)
  })

}


export default __exports__